/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import IOSComingSoon from "components/IOSComingSoon";
import "./index.css";

// Soft UI Context Provider
import { ArgonControllerProvider } from "context";

// react-perfect-scrollbar component
import PerfectScrollbar from "react-perfect-scrollbar";

// react-perfect-scrollbar styles
import "react-perfect-scrollbar/dist/css/styles.css";

const container = document.getElementById("root");
const root = createRoot(container);

const isDownloadRoute = window.location.pathname.replace(/\/+$/, "") === "/download";

if (isDownloadRoute) {
  const platform = navigator.userAgentData?.platform || navigator.platform || "";
  const deviceInfo = `${navigator.userAgent || ""} ${platform}`;
  const isAndroid = /android/i.test(deviceInfo);
  const isIOS = /iPhone|iPad|iPod/i.test(deviceInfo) ||
    (platform === "MacIntel" && navigator.maxTouchPoints > 1);

  if (isAndroid) {
    window.location.replace(
      process.env.REACT_APP_ANDROID_APP_URL ||
        "https://play.google.com/store/apps/details?id=com.edushala.app"
    );
  } else if (isIOS) {
    root.render(<IOSComingSoon />);
  } else {
    window.location.replace(
      process.env.REACT_APP_EDUSHALA_WEBSITE_URL || "https://edushalaacademy.com"
    );
  }
} else {
  root.render(
    <BrowserRouter>
      <ArgonControllerProvider>
        <PerfectScrollbar>
          <App />
        </PerfectScrollbar>
      </ArgonControllerProvider>
    </BrowserRouter>
  );
}


